import { AdminUserPage } from "@/features/admin-user/pages/AdminUser";

const AdminUser = () => {
  return <AdminUserPage />;
};

export default AdminUser;
